<template>
	<input type="number" class="form-control">
</template>
<script>
	export default{
		props: ['value'],

		mounted(){
			var vm = this
            
			$(this.$el)
			.val(this.value)
            .on('change', function () {
                vm.$emit('input', this.value)
            });
		},

		watch: {
            value: function (value) {
                $(this.$el).val(value);
            },
        },
	}
</script>